import { UseQueryResult, useQuery } from '@tanstack/react-query';
import {
    MarketplacePagedResult,
    MarketplaceSolutionsSectionDataFilters,
} from '@models/section/marketplaceSolutionsSection';
import { Industry, PartnerSolutionCategory, Region, MarketplaceSolution } from '@models/marketplaceFilters';
import {
    getMarketplaceCategoryFilter,
    getMarketplaceIndustryFilter,
    getMarketplaceRegionFilter,
    getAllMarketplaceSolutions,
} from '@services/marketplaceFilterService';
import { getQueryStringFromFilters } from '@helpers/marketplaceSolutionHelper';

export function useMarketplaceRegions(): UseQueryResult<MarketplacePagedResult<Region>> {
    return useQuery({
        queryKey: ['marketplaceRegions'],
        queryFn: getMarketplaceRegionFilter,
    });
}

export function useMarketplaceCategories(): UseQueryResult<PartnerSolutionCategory[]> {
    return useQuery({
        queryKey: ['marketplaceCategories'],
        queryFn: getMarketplaceCategoryFilter,
    });
}

export function useMarketplaceIndustries(): UseQueryResult<Industry[]> {
    return useQuery({
        queryKey: ['marketplaceIndustries'],
        queryFn: getMarketplaceIndustryFilter,
    });
}

const mpApiUrl = '/api/mp_proxy/solutions/public-view-solutions';

export function useMarketplaceSolutionsByFilters(
    filters?: MarketplaceSolutionsSectionDataFilters
): UseQueryResult<MarketplacePagedResult<MarketplaceSolution>> {
    const filterQuery = getQueryStringFromFilters(filters);

    const api = filterQuery ? `${mpApiUrl}?${filterQuery}` : mpApiUrl;

    return useQuery({
        queryKey: ['marketplaceSolutions', filters],
        queryFn: () => getAllMarketplaceSolutions(api),
    });
}

export function useMarketplaceSolutionsByRegion(
    region: MarketplaceSolutionsSectionDataFilters['region'],
    enabled?: boolean
): UseQueryResult<MarketplacePagedResult<MarketplaceSolution>> {
    const api = `${mpApiUrl}?localRegion=${region}`;

    return useQuery({
        queryKey: ['marketplaceSolutions', region],
        queryFn: () => getAllMarketplaceSolutions(api),
        enabled,
    });
}
